/**
 * Backend base URL. Cambia qui per usare localhost o produzione.
 * - Produzione: 'https://api.bebmeccanica.it'
 * - Locale (Laravel): 'http://localhost:8000' (o la porta del tuo BE)
 */
export const API_BASE = 'https://api.bebmeccanica.it';
// export const API_BASE = 'http://localhost:8000';

export const domain = API_BASE;
export const apiURL = `${API_BASE}/api`;

export const appHostURL = window.location.host;
